import Client from './client';

export default class RestrictionProducts extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(organization, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/products`, options);
  }

  getById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/products/${id}`, options);
  }

  postDecisionsById(organization, id, options = {}) {
    return this.makeRequest(`${this.host}/jailhouse/restriction/${organization}/products/${id}/decisions`, {
      ...options,
       method: 'POST',
    });
  }

}
